module.exports = __webpack_public_path__ + "media/application/images/services/secondary_nav/alliances-and-partnering-5ba17acfba5ceabe491d876231cc2cd2.jpg";